export const siteInfo = {
  name: '樱花漫画网',
  slogan: '随时随地，免费看漫画',
  intro: '樱花漫画网是国内领先的免费漫画在线阅读平台，汇聚海量精品漫画资源，涵盖热门免费韩漫、经典免费日漫和优质免费国漫。我们坚持每日更新，采用流畅的下拉式阅读体验，让每一位漫迷都能在这里找到心仪的作品——追更不花一分钱，畅享漫画的无限乐趣。无论是热血冒险、恋爱校园，还是奇幻魔法、悬疑推理，樱花漫画网都是你最佳的漫画阅读伴侣。',
};

export const heroStats = [
  { label: '日更新漫画', value: '200+' },
  { label: '在线漫画总数', value: '30,000+' },
  { label: '活跃漫迷', value: '500万+' },
];

export const updates = [
  { date: '2026.07.29', title: '《剑与魔法》第 128 话更新 —— 决战之日来临', tag: '热门日漫', link: '#ranking' },
  { date: '2026.07.29', title: '《都市传说》番外篇《夜行者》正式上线', tag: '新作首发', link: '#index' },
  { date: '2026.07.28', title: '《星辰变》第三季回归，每周二、五更新', tag: '国漫力作', link: '#ranking' },
  { date: '2026.07.28', title: '《恋爱方程式》最终话发布，完结撒花', tag: '完结推荐', link: '#cards' },
  { date: '2026.07.27', title: '《暗夜猎手》新系列「深渊篇」连载启动', tag: '韩漫精选', link: '#index' },
  { date: '2026.07.27', title: '《美食大冒险》第二季动画化决定，原漫画热度飙升', tag: '改编资讯', link: '#carousel' },
  { date: '2026.07.26', title: '《机甲战士》连载五周年纪念回限时免费', tag: '限时福利', link: '#carousel' },
  { date: '2026.07.26', title: '《妖精之森》高清重置版全话上线', tag: '经典重温', link: '#cards' },
  { date: '2026.07.25', title: '《校园日记》日更突破 1000 话里程碑', tag: '人气连载', link: '#ranking' },
];

export const aboutContent = {
  title: '关于樱花',
  paragraphs: [
    '樱花漫画网诞生于对漫画的无限热爱。我们相信，好的漫画应该属于每一个人——不需要付费墙，不需要复杂的订阅，随时随地打开就能看。自上线以来，我们已累计收录超过三万部漫画作品，涵盖韩漫、日漫、国漫三大主流品类，每日保持两百部以上的内容更新，确保漫迷们永远有最新鲜的阅读选择。',
    '我们的团队由资深漫画编辑和技术工程师组成，日夜兼程为读者筛选优质内容、优化阅读体验。下拉式阅读模式让你告别翻页的繁琐，高清画质保留了原作的每一处细节。无论你是通勤路上想刷几话韩漫，还是周末窝在沙发追最新日漫连载，樱花漫画网都是你最贴心的漫画伙伴。',
    '未来，我们将持续拓展漫画品类，引入更多正版授权作品，并不断打磨产品体验。让免费漫画走进更多人的生活——这是我们的初心，也是我们不变的承诺。',
  ],
};

export const mediaCards = [
  {
    title: '新番导览：七月最值得追的 10 部日漫',
    desc: '炎炎夏日，新番扎堆。我们精选了本月最值得入坑的十部连载漫画，从热血战斗到治愈日常，总有一部适合你。',
    imageSeq: 'media-01',
    imageQuery: 'Japanese%20manga%20reading%20scene%20with%20warm%20lighting%2C%20cozy%20reading%20nook%20with%20comic%20books%20open%2C%20soft%20natural%20light%20through%20curtains%2C%20aesthetic%20and%20artistic%20composition%2C%20warm%20tones%2C%20editorial%20style%20with%20minimal%20background',
  },
  {
    title: '韩漫入门指南：从零开始看懂韩式条漫',
    desc: '韩漫独特的竖屏下拉式阅读和精致的全彩画风让人眼前一亮。这份指南帮你快速入门韩漫世界。',
    imageSeq: 'media-02',
    imageQuery: 'Korean%20webtoon%20style%20illustration%20on%20tablet%20screen%2C%20colorful%20vertical%20scroll%20comic%20display%2C%20modern%20cozy%20interior%20with%20warm%20ambient%20lighting%2C%20digital%20art%20aesthetic%2C%20clean%20minimal%20background%20with%20soft%20shadows',
  },
  {
    title: '国漫崛起：不可错过的国产漫画力作',
    desc: '从仙侠古风到赛博朋克，国漫正在用独特的东方美学征服全球读者。发现你身边的宝藏国漫。',
    imageSeq: 'media-03',
    imageQuery: 'Chinese%20manhua%20art%20style%20illustration%20with%20ink%20wash%20painting%20aesthetic%2C%20traditional%20eastern%20elements%20blended%20with%20modern%20comic%20style%2C%20warm%20paper%20texture%20background%2C%20artistic%20editorial%20photography%2C%20soft%20diffused%20lighting',
  },
];

export const features = [
  {
    icon: 'ri-stack-line',
    title: '海量漫画资源',
    desc: '收录超过三万部漫画，涵盖韩漫、日漫、国漫三大品类，热门冷门一网打尽，总有你爱的那一部。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清无损画质',
    desc: '所有漫画均采用高清图片加载，保留原作每一处线条与色彩细节，带来沉浸式视觉享受。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速同步更新',
    desc: '与各大漫画平台同步更新，每日超 200 部漫画刷新，第一时间追更，绝不错过任何精彩。',
  },
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式流畅阅读',
    desc: '专为漫画优化的下拉式阅读模式，无需频繁点击翻页，一滑到底，沉浸追更更顺畅。',
  },
  {
    icon: 'ri-heart-line',
    title: '完全免费无广告打扰',
    desc: '坚持免费阅读原则，无需会员、无需付费，清爽界面无弹窗，纯享漫画阅读乐趣。',
  },
];

export const ranking = [
  { rank: 1, title: '剑与魔法', tag: '日漫·热血冒险', heat: '本周热度 986万', change: 'up' },
  { rank: 2, title: '都市传说', tag: '韩漫·悬疑惊悚', heat: '评论破 12万', change: 'up' },
  { rank: 3, title: '星辰变', tag: '国漫·仙侠修真', heat: '收藏增长 320%', change: 'up' },
  { rank: 4, title: '恋爱方程式', tag: '日漫·校园恋爱', heat: '完结热度飙升', change: 'hot' },
  { rank: 5, title: '暗夜猎手', tag: '韩漫·动作奇幻', heat: '新作强势入榜', change: 'new' },
];

export const indexTopics = [
  { title: '热血冒险', desc: '战斗、成长与伙伴的史诗旅程', icon: 'ri-sword-line', count: '3,200+ 部' },
  { title: '恋爱校园', desc: '青春悸动，甜蜜与酸涩交织', icon: 'ri-heart-pulse-line', count: '2,800+ 部' },
  { title: '奇幻魔法', desc: '在异世界中展开无尽冒险', icon: 'ri-magic-line', count: '4,100+ 部' },
  { title: '科幻机甲', desc: '未来世界与钢铁洪流的碰撞', icon: 'ri-rocket-line', count: '1,600+ 部' },
  { title: '悬疑推理', desc: '层层谜题，烧脑刺激的阅读体验', icon: 'ri-search-eye-line', count: '2,300+ 部' },
  { title: '古风仙侠', desc: '水墨江湖，东方幻想的极致浪漫', icon: 'ri-mist-line', count: '3,500+ 部' },
  { title: '搞笑日常', desc: '轻松解压，笑到停不下来', icon: 'ri-emotion-laugh-line', count: '2,100+ 部' },
  { title: '美食生活', desc: '舌尖上的漫画，治愈你的味蕾', icon: 'ri-restaurant-line', count: '900+ 部' },
];

export const contactInfo = {
  title: '联系我们',
  desc: '无论你是想推荐好漫画、报告内容问题，还是有商务合作意向，都欢迎随时联系我们。樱花漫画网期待听到每一位漫迷的声音。',
  email: 'contact@yinghuacomics.com',
  qq: '读者交流群：888-666-999',
  wechat: '公众号：樱花漫画网',
  workTime: '在线客服工作时间：每日 9:00 - 22:00',
};

export const comments = [
  {
    name: '爱吃猫的鱼',
    avatar: '🐟',
    date: '3 天前',
    content: '真的太好用了！之前为了追韩漫每个月花好几十，自从朋友推荐了樱花漫画网，全部免费看，更新还特别快。画质也很清晰，下拉阅读的方式比翻页舒服太多了。已经推荐给整个宿舍了！',
    comic: '在读《都市传说》',
  },
  {
    name: '星辰大海',
    avatar: '🌟',
    date: '1 周前',
    content: '作为国漫爱好者，樱花漫画网的国漫库真的很丰富。好多之前在别的平台找不到的国产漫画这里都有，而且分类很清晰，找起来特别方便。希望可以一直做下去，支持！',
    comic: '在读《星辰变》',
  },
  {
    name: '二次元居民',
    avatar: '🎀',
    date: '2 周前',
    content: '日漫更新速度和日本同步，这点真的太赞了。以前要等翻译组，现在这边基本同步就出了。界面也很干净，没有乱七八糟的广告弹窗，阅读体验满分。',
    comic: '在读《剑与魔法》',
  },
  {
    name: '漫画老司机',
    avatar: '📚',
    date: '3 周前',
    content: '看了十几年漫画，樱花漫画网是我用过最舒服的免费漫画站。资源全、更新快、画质好，而且完全不需要注册就能看，对懒人太友好了。排行榜功能也很好，帮我发现了不少宝藏冷门漫画。',
    comic: '在读《暗夜猎手》',
  },
];

export const carouselItems = [
  {
    title: '《剑与魔法》最终章突入',
    desc: '连载五年的日漫霸主迎来最终决战，主角与魔王宿命对决，全漫迷翘首以盼的史诗终章。',
    tag: '日漫·连载中',
    imageSeq: 'carousel-01',
    imageQuery: 'Epic%20fantasy%20manga%20illustration%20with%20hero%20wielding%20sword%20facing%20ancient%20dragon%2C%20dramatic%20lighting%20with%20warm%20golden%20accents%2C%20detailed%20linework%20style%2C%20atmospheric%20composition%20with%20soft%20dark%20background%2C%20anime%20art%20aesthetic',
  },
  {
    title: '韩漫精选：2026 上半年必看清单',
    desc: '从悬疑惊悚到浪漫爱情，我们整理了上半年最不容错过的韩漫佳作合集。',
    tag: '韩漫·专题推荐',
    imageSeq: 'carousel-02',
    imageQuery: 'Korean%20webtoon%20style%20art%20collection%20showcase%2C%20colorful%20character%20illustrations%20on%20digital%20display%2C%20modern%20minimal%20composition%2C%20warm%20ambient%20lighting%20on%20neutral%20background%2C%20vibrant%20yet%20soft%20color%20palette',
  },
  {
    title: '国漫之光：《星辰变》第三季',
    desc: '现象级国漫回归！全新画风升级，世界观大幅拓展，每周二、五与你不见不散。',
    tag: '国漫·热播中',
    imageSeq: 'carousel-03',
    imageQuery: 'Chinese%20ink%20painting%20style%20fantasy%20illustration%20with%20celestial%20beings%20and%20floating%20mountains%2C%20traditional%20eastern%20aesthetic%20blended%20with%20modern%20digital%20art%2C%20ethereal%20golden%20light%2C%20mystical%20atmosphere%20with%20soft%20clouds',
  },
  {
    title: '夏日纳凉特辑：恐怖悬疑漫画精选',
    desc: '炎炎夏日最需要来点清凉的！精选 20 部高口碑恐怖悬疑漫画，让你脊背发凉。',
    tag: '专题·纳凉特辑',
    imageSeq: 'carousel-04',
    imageQuery: 'Mysterious%20atmospheric%20horror%20manga%20illustration%20with%20subtle%20eerie%20elements%2C%20dark%20moody%20composition%20with%20warm%20candlelight%20accents%2C%20gothic%20aesthetic%2C%20soft%20shadows%20and%20textured%20background%2C%20artistic%20editorial%20style',
  },
  {
    title: '新手入门：漫画分类完全指南',
    desc: '热血、恋爱、奇幻、悬疑……搞不懂漫画分类？这份指南帮你快速找到最爱。',
    tag: '指南·新手必读',
    imageSeq: 'carousel-05',
    imageQuery: 'Organized%20bookshelf%20filled%20with%20colorful%20manga%20volumes%20arranged%20by%20genre%2C%20cozy%20reading%20space%20with%20warm%20desk%20lamp%20lighting%2C%20neat%20and%20inviting%20composition%2C%20soft%20natural%20tones%2C%20lifestyle%20editorial%20photography',
  },
  {
    title: '《恋爱方程式》完结纪念专题',
    desc: '陪伴我们三年的校园恋爱经典落下帷幕，回顾主角们的成长与感动瞬间。',
    tag: '日漫·完结纪念',
    imageSeq: 'carousel-06',
    imageQuery: 'Romantic%20school%20life%20manga%20illustration%20with%20cherry%20blossoms%20falling%2C%20two%20characters%20under%20pink%20tree%2C%20warm%20spring%20lighting%2C%20nostalgic%20and%20sweet%20atmosphere%2C%20soft%20pastel%20color%20palette%2C%20anime%20art%20style',
  },
];

export const appEntry = {
  title: '随时随地，掌上追漫',
  desc: '樱花漫画网完美适配手机和平板浏览器，无需下载 APP，打开浏览器就能享受流畅的下拉式漫画阅读体验。通勤路上、午休间隙、睡前时光——你的漫画，随时待命。',
  features: ['无需下载，即开即看', '自适应手机与平板', '下拉式竖屏阅读', '省流量高清模式'],
};

export const cardItems = [
  {
    title: '《都市传说》番外篇',
    desc: '人气韩漫衍生新作，揭开正篇未解之谜，暗黑都市新篇章正式开启。',
    tag: '韩漫·悬疑',
    imageSeq: 'card-01',
    imageQuery: 'Mysterious%20urban%20night%20scene%20illustration%20in%20Korean%20webtoon%20style%2C%20neon%20signs%20reflecting%20on%20wet%20street%2C%20moody%20atmospheric%20lighting%2C%20dark%20blue%20and%20warm%20orange%20contrast%2C%20cinematic%20composition',
  },
  {
    title: '《妖精之森》重置版',
    desc: '经典奇幻漫画全面画质升级，全彩重新绘制，高清重温童年回忆。',
    tag: '日漫·奇幻',
    imageSeq: 'card-02',
    imageQuery: 'Enchanted%20forest%20fantasy%20illustration%20with%20glowing%20fireflies%20and%20magical%20creatures%2C%20lush%20greenery%20with%20soft%20golden%20light%20rays%2C%20whimsical%20atmosphere%2C%20detailed%20natural%20elements%2C%20ethereal%20fantasy%20art%20style',
  },
  {
    title: '《美食大冒险》第二季',
    desc: '美食与冒险的奇妙碰撞！动画化后人气暴涨，漫画原作更精彩。',
    tag: '国漫·美食',
    imageSeq: 'card-03',
    imageQuery: 'Delicious%20food%20illustration%20with%20adventure%20elements%2C%20steaming%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20appetizing%20composition%2C%20cozy%20and%20inviting%20atmosphere%2C%20Japanese%20anime%20food%20art%20style',
  },
  {
    title: '《机甲战士》周年特辑',
    desc: '连载五年经典科幻漫画，周年纪念特辑限时免费开放阅读。',
    tag: '日漫·科幻',
    imageSeq: 'card-04',
    imageQuery: 'Futuristic%20mecha%20robot%20illustration%20standing%20in%20urban%20landscape%2C%20detailed%20mechanical%20design%2C%20dramatic%20sunset%20lighting%2C%20cinematic%20composition%2C%20warm%20golden%20hour%20tones%2C%20sci-fi%20anime%20art%20style',
  },
  {
    title: '《校园日记》1000 话纪念',
    desc: '人气校园日常漫画达成千话里程碑，粉丝回馈活动进行中。',
    tag: '国漫·校园',
    imageSeq: 'card-05',
    imageQuery: 'Peaceful%20school%20campus%20scene%20with%20cherry%20blossom%20trees%2C%20students%20walking%20on%20path%2C%20warm%20spring%20sunlight%2C%20nostalgic%20and%20gentle%20atmosphere%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20slice%20of%20life%20anime%20style',
  },
];

export const faqItems = [
  {
    q: '樱花漫画网真的完全免费吗？',
    a: '是的，樱花漫画网坚持完全免费阅读原则。无需注册会员、无需充值、无需购买任何服务，所有漫画均可免费在线浏览。我们通过广告合作维持运营，但承诺绝不使用弹窗广告或强制广告影响阅读体验。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '我们每日更新超过 200 部漫画内容，与各大漫画平台保持同步。热门连载漫画通常在其原版更新后 24 小时内上线中文版，确保你第一时间看到最新内容。推荐使用「更新快讯」模块查看每日最新上架。',
  },
  {
    q: '支持手机和平板阅读吗？',
    a: '完全支持。樱花漫画网采用响应式设计，自动适配手机、平板和电脑屏幕。我们特别优化了下拉式竖屏阅读模式，在手机上也能享受流畅的漫画阅读体验，无需下载任何 APP。',
  },
  {
    q: '漫画画质怎么样？可以调整吗？',
    a: '所有漫画均以高清画质呈现，保留原作细节。在阅读界面，你可以根据网络情况自由切换高清和流畅两种画质模式，既保证视觉效果又兼顾加载速度。',
  },
  {
    q: '如何推荐漫画或反馈问题？',
    a: '你可以通过「联系我们」模块中的邮箱、QQ 群或微信公众号与我们沟通。无论是推荐好看的漫画、报告内容问题，还是提出产品建议，我们都会认真对待每一条反馈。',
  },
];

export const topics = [
  { name: '日漫推荐', count: '12.8万', hot: true },
  { name: '韩漫精选', count: '9.6万', hot: true },
  { name: '国漫崛起', count: '8.3万', hot: true },
  { name: '热血番', count: '15.2万', hot: false },
  { name: '恋爱番', count: '11.4万', hot: false },
  { name: '搞笑番', count: '7.8万', hot: false },
  { name: '悬疑番', count: '6.5万', hot: false },
  { name: '奇幻番', count: '10.1万', hot: false },
  { name: '校园番', count: '8.7万', hot: false },
  { name: '新番速递', count: '5.3万', hot: true },
  { name: '经典回顾', count: '4.9万', hot: false },
];

export const footerLinks = [
  { label: '更新快讯', href: '#updates' },
  { label: '关于我们', href: '#about' },
  { label: '热门榜单', href: '#ranking' },
  { label: '专题索引', href: '#index' },
  { label: '读者评价', href: '#comments' },
  { label: '联系我们', href: '#contact' },
  { label: '常见问题', href: '#faq' },
  { label: '热门话题', href: '#topics' },
];